import './App.css';
import Routes from "./routes";
import { connect } from "react-redux";
import { onReload } from './store/auth/actions'
import { onReloadAdmin } from './store/authAdmin/actions'
import PropTypes from 'prop-types';
import { useEffect } from 'react';

function App({ onReload, onReloadAdmin, ...props }) {
    useEffect(() => {
        onReload()
    }, [onReload])
    useEffect(() => {
        onReloadAdmin()
    }, [onReloadAdmin])
    return (
        <div className="App">
            <div id="google_translate_element"></div>
            <Routes />
        </div>
    );
}


App.propTypes = {
    onReload: PropTypes.func.isRequired,
    onReloadAdmin: PropTypes.func.isRequired
};
const mapStateToProps = (state) => ({
    state: state
})
const mapDispatchToProps = { onReload, onReloadAdmin }
export default connect(mapStateToProps, mapDispatchToProps)(App);
